import { render, staticRenderFns } from "./RincianTransaksi.vue?vue&type=template&id=65456aed"
import script from "./RincianTransaksi.vue?vue&type=script&lang=js"
export * from "./RincianTransaksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports